import { SystemBase2 } from "@inter-ikea-core/core-toolbox";
import { ApiSystemIds, ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range/dist/storage2ComponentIDs";
import { MOUNTING_RAIL_RIGHT_SIDE_UPRIGHT_CONNECTORS } from "../constants/connectorKeys";
import { findUniqueConnections } from "../utils/connectorHelpers";
import { resizeMountingRailModel } from "../functions/MountingRails";
import { NO_MOUNTING_RAIL, NO_UPRIGHTS } from "../constants/errors";
import { UPDATE } from "@inter-ikea-storagetwo/range/dist/constants";
import { getViewerObject } from "@inter-ikea-storagetwo/range/dist/functions/componentGetters";
import { getUprights, hasUprights } from "../utils/sectionsHelpers";
export default class OnAddMountingRailToSceneSystem2 extends SystemBase2 {
    constructor(core, viewer) {
        super(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID, ComponentIds.IN_SCENE_COMPONENT_ID);
        this.core = core;
        this.viewer = viewer;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = [
            ApiSystemIds.CONNECTION_PARENTING_SYSTEM_ID,
        ];
        this.systemsAfterMe = null;
        this.id = "OnAddMountingRailToSceneSystem2";
        this.isRightSideUpright = (connection) => MOUNTING_RAIL_RIGHT_SIDE_UPRIGHT_CONNECTORS.includes(connection.hostConnector.key);
        this.isMountingRail = (entity) => entity.hasComponent(COMPONENT_IDS.MOUNTING_RAIL_COMPONENT);
        this.isUpright = (entity) => entity.hasComponent(COMPONENT_IDS.UPRIGHT_COMPONENT);
    }
    onAddComponent(_entity, _newComponent) {
        if (!this.isUpright(_entity))
            return;
        super.onAddComponent(_entity, _newComponent);
        const mountingRail = HierarchyUtils.parent(_entity);
        if (!mountingRail)
            throw new Error(NO_MOUNTING_RAIL);
        if (!mountingRail.hasComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID))
            return;
        const viewerObject = getViewerObject(mountingRail);
        const viewerObjectId = viewerObject === null || viewerObject === void 0 ? void 0 : viewerObject.getViewerObjectId();
        if (!this.isRightSideUpright(_newComponent.connections[0]) || !mountingRail)
            return;
        resizeMountingRailModel(mountingRail, _entity, viewerObject, this.viewer);
        this.viewer
            // @ts-ignore
            .get_object_transform_changed_observable(viewerObjectId)
            .add((_o) => resizeMountingRailModel(mountingRail, _entity, viewerObject, this.viewer));
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        if (!this.isUpright(_entity))
            return;
        super.onUpdateComponent(_entity, _oldComponent, _newComponent);
        const mountingRail = HierarchyUtils.parent(_entity);
        if (!mountingRail)
            throw new Error(NO_MOUNTING_RAIL);
        const viewerObject = getViewerObject(mountingRail);
        const { connections, action } = findUniqueConnections(_newComponent.connections, _oldComponent.connections);
        if (!this.isRightSideUpright(connections[0]) ||
            !mountingRail ||
            action !== UPDATE)
            return;
        resizeMountingRailModel(mountingRail, _entity, viewerObject, this.viewer);
    }
    onAddComponent2(_entity, _newComponent) {
        if (!(this.isMountingRail(_entity) && hasUprights(_entity)))
            return;
        const { rightUpright } = getUprights(_entity);
        const viewerObject = getViewerObject(_entity);
        if (!rightUpright)
            throw new Error(NO_UPRIGHTS);
        resizeMountingRailModel(_entity, rightUpright, viewerObject, this.viewer);
    }
}
